import asyncActionTypes from '../actions/types.js';
import { deleteCookie } from '../../scripts/utilities/helpers.js';
import safeLocalStorage from '../../scripts/utilities/safe-local-storage';

import { sendNewRelicEvent } from '../../scripts/utilities/newrelic/newrelic-micro-sendEvent.js';
import { RESULT_STATE } from '../../scripts/utilities/newrelic/newrelic-constants.js';

const initialState = {
  storefront: 'es-mx',
  loadingPorfileRequestStart: false,
  userProfLogout: undefined,
};

const UserProfileSessionMicro = (state = initialState, action) => {
  switch (action.type) {
    // user logout
    case asyncActionTypes.USER_PROFILE_LOGOUT.START:
      return {
        ...state,
        loadingPorfileRequestStart: true,
      };

    case asyncActionTypes.USER_PROFILE_LOGOUT.SUCCESS:
      if (window.newrelic) { 
        sendNewRelicEvent({
          actionType: 'USER_LOGIN',
          ffn: action?.payload?.accountNumber,
          resultState: RESULT_STATE.SUCCESS,
          state,
        });
      }

      safeLocalStorage.removeItem('initials');
      safeLocalStorage.removeItem('firstName');
      deleteCookie('userSession');
      deleteCookie('userSessionCorporate');

      return initialState;

    case asyncActionTypes.USER_PROFILE_LOGOUT.FAIL:
      if (window.newrelic) {
        sendNewRelicEvent({
          actionType: 'USER_LOGIN',
          ffn: action?.payload?.accountNumber,
          state,
          result: {
            errorCode: action.payload?.response?.code,
          },
          resultState: RESULT_STATE.FAILURE,
        });
      }

      return {
        ...state,
        loadingPorfileRequestStart: false,
        userProfLogout: false, // We'll need this in the future to send the correct error to GTM.
      };

    default:
      return state;
  }
};

export default UserProfileSessionMicro;
